import { RootViewModel } from './root-view-model';
import type { IdentityInterface, ModelInterface, VersionPropertyViewModelInterface } from '@nts/std/interfaces';
import type { OCCRootViewModelInterface } from '@nts/std/interfaces';

export class OCCRootViewModel<
    TModel extends ModelInterface<TIdentity>, TIdentity extends IdentityInterface
> extends RootViewModel<TModel, TIdentity> implements OCCRootViewModelInterface<TIdentity, TModel> {

    private _occ: VersionPropertyViewModelInterface;

    get occ(): VersionPropertyViewModelInterface {
        return this.getVersionPropertyViewModel({
            action: (value) => { this._occ = value; },
            value: this._occ,
            propertyName: 'occ'
        });
    }
}
